import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, ZipRecruiterSourcingFunnel } from "@/types";

export function useGetZipRecruiterSourcingFunnel() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["zip-recruiter-sourcing-funnel", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/zip-recruiter-sourcing-request-rated-profiles/funnel-counts`;
      const res = await guacHttpClient.get<
        ZipRecruiterSourcingFunnel,
        HttpResponse<ZipRecruiterSourcingFunnel>
      >(path);
      return res.data;
    },
  });
}
